var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
        },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-header",
                { staticClass: "md-card-header-icon md-card-header-blue" },
                [
                  _c(
                    "div",
                    { staticClass: "card-icon" },
                    [_c("md-icon", [_vm._v("payment")])],
                    1
                  ),
                ]
              ),
              _c(
                "md-card-content",
                [
                  _c(
                    "tabs",
                    {
                      attrs: {
                        "tab-name": [
                          "Enterprise Agreements",
                          "Stripe Accounts",
                        ],
                      },
                    },
                    [
                      _c("template", { slot: "tab-pane-1" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            !_vm.licenseDetails || !_vm.licenseDetails.length
                              ? [_c("p", [_vm._v("No result found.")])]
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "column" },
                                    [
                                      _c(
                                        "md-table",
                                        [
                                          _c(
                                            "md-table-row",
                                            [
                                              _c("md-table-head", [
                                                _vm._v("Transaction Id"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Product"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Agreement Date"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Payment Date"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Amount"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Payment Source"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.licenseDetails,
                                            function (item, itemIndex) {
                                              return _c(
                                                "md-table-row",
                                                {
                                                  key:
                                                    "licenseDetails-" +
                                                    itemIndex,
                                                  staticClass: "ea",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showEAItems(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          item.transactionId
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          item.productName
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm._f("dateFormat")(
                                                            item.agreementDate,
                                                            _vm.DATE_TYPES
                                                              .internationalDate
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm._f("dateFormat")(
                                                            item.paymentDate,
                                                            _vm.DATE_TYPES
                                                              .internationalDate
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          item.currency +
                                                            " " +
                                                            _vm.formatNumber(
                                                              item.amount,
                                                              2
                                                            )
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          item.paymentSource
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]),
                      _c("template", { slot: "tab-pane-2" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            !_vm.billingAccounts || !_vm.billingAccounts.length
                              ? [_c("p", [_vm._v("No billing account found.")])]
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "column" },
                                    [
                                      _c(
                                        "md-table",
                                        [
                                          _c(
                                            "md-table-row",
                                            [
                                              _c("md-table-head", [
                                                _vm._v("Subscription Id"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Subscription Status"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Quantity"),
                                              ]),
                                              _c("md-table-head", [
                                                _vm._v("Total Price"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.billingAccounts,
                                            function (acct) {
                                              return _vm._l(
                                                acct.subscriptions,
                                                function (item, itemIndex) {
                                                  return _c(
                                                    "md-table-row",
                                                    {
                                                      key:
                                                        acct.billingAcountId +
                                                        "sub-" +
                                                        itemIndex,
                                                    },
                                                    [
                                                      _c("md-table-cell", [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              item.paymentSubscriptionId
                                                            ) +
                                                            "\n                                                    "
                                                        ),
                                                      ]),
                                                      _c("md-table-cell", [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              item.subscriptionStatus
                                                            ) +
                                                            "\n                                                    "
                                                        ),
                                                      ]),
                                                      _c("md-table-cell", [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              item.quantity
                                                            ) +
                                                            "\n                                                    "
                                                        ),
                                                      ]),
                                                      _c("md-table-cell", [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              item.currency +
                                                                " " +
                                                                _vm.formatNumber(
                                                                  item.totalPrice,
                                                                  2
                                                                )
                                                            ) +
                                                            "\n                                                    "
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                }
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }